import { SelectInput } from 'components';
import { Flex, Grid, Text } from 'ui';
import { ImportLogsFilters } from '../hooks/useImportLogsFilters';
import { ImportLogsLegend } from './ImportLogsLegend';

type ImportLogsFilterProps = Pick<
  ImportLogsFilters,
  'handlers' | 'filters' | 'options'
>;

export const ImportLogsFilter = ({
  handlers,
  filters,
  options,
}: ImportLogsFilterProps) => (
  <Grid gridTemplateColumns="1fr" gridGap="s30" p="s20">
    <Flex flexDirection="column">
      <Text lineHeight="lh300" mb="s10">
        Importer
      </Text>
      <SelectInput
        placeholder="Filter by importer"
        options={options.importerOptions}
        value={filters.selectedImporter}
        onChange={handlers.handleImporterChange}
        labelResolver={(val) => val}
        keyResolver={(val) => val}
      />
    </Flex>
    <ImportLogsLegend />
  </Grid>
);
